module.exports = __webpack_public_path__ + "img/product-tutorial-3-small-flower.be50eae8.svg";